<template>
  <vue-context ref="contextMenu">
    <ul
      class="context-menu-list"
      slot-scope="child"
    >
      <li
        class="context-menu-item title"
        :style="{ 'background-color': themeConfig.navbarColor + ' !important' }"
      >
        {{ child && child.data ? child.data.name : '' }}
      </li>

      <!-- Folder actions -->
      <li
        v-if="child.data && child.data.isFolder"
        class="context-menu-item"
        @click="emitAction('edit-folder', child.data)"
      >
        Editar Nombre
      </li>
      <li
        v-if="child.data && child.data.isFolder"
        class="context-menu-item"
        @click="emitAction('add-folder', child.data)"
      >
        Agregar Carpeta
      </li>
      <li
        v-if="child.data && child.data.isFolder"
        class="context-menu-item"
        @click="emitAction('add-parameter', child.data)"
      >
        Agregar parámetro
      </li>

      <!-- Parameter actions -->
      <li
        v-if="child.data && !child.data.isFolder"
        class="context-menu-item"
        @click="emitAction('edit-parameter', child.data)"
      >
        Editar Item
      </li>
      <li
        v-if="child.data && !child.data.isFolder"
        class="context-menu-item"
        @click="emitAction('copy-parameter', child.data)"
      >
        Copiar Item
      </li>
    </ul>
  </vue-context>
</template>

<script>
import '@core/scss/base/plugins/extensions/ext-component-context-menu.scss'
import { VueContext } from 'vue-context'
import themeConfig from '@/../themeConfig'

export default {
  name: 'ConfigParamsContextMenu',
  components: {
    VueContext,
  },
  props: {
    node: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      themeConfig,
    }
  },
  methods: {
    open(event, node) {
      this.$refs.contextMenu.open(event, node)
    },
    emitAction(action, node) {
      this.$emit('action', { action, node })
    },
  },
}
</script>
